import React from 'react';
import ReactDOM from 'react-dom';

if (process.env.NODE_ENV === 'development' && window.Promise && React && ReactDOM) {
  const axe = require('react-axe');
  axe(React, ReactDOM, 1000);
}
